import React from 'react';
export const CuratorSection = () => {
  return <div className="bg-white py-16" data-id="element-42">
      <div className="container mx-auto px-4" data-id="element-43">
        <h2 className="text-3xl font-bold text-center mb-12" data-id="element-44">
          Meet the Curator
        </h2>
        <div className="max-w-3xl mx-auto bg-gray-50 p-8 rounded-lg" data-id="element-45">
          <div className="flex flex-col md:flex-row items-center" data-id="element-46">
            <div className="md:w-1/3 mb-6 md:mb-0" data-id="element-47">
              <div className="w-32 h-32 bg-gray-300 rounded-full mx-auto flex items-center justify-center" data-id="element-48">
                <span className="text-4xl font-bold text-gray-600" data-id="element-49">MS</span>
              </div>
            </div>
            <div className="md:w-2/3 md:pl-8" data-id="element-50">
              <h3 className="text-xl font-bold mb-2" data-id="element-51">Miguel Santos</h3>
              <p className="text-gray-600 mb-4" data-id="element-52">Portuguese Sports Historian</p>
              <p className="text-gray-700 mb-4" data-id="element-53">
                This project was curated by Miguel Santos, a Portuguese sports
                historian who has written extensively on European football and
                contributed to publications like Marca and A Bola.
              </p>
              <p className="text-gray-700" data-id="element-54">
                As both a Ronaldo fan and a respected chronicler of the game,
                Miguel led this edition to ensure it blends football accuracy,
                artistry, and collector value.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};